<advanced-filter (onSubmit)="applyFilter()" *ngIf="isCoLogin()"></advanced-filter>
<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
<wl-card heading="Disbursed Page ({{totalCount}})" subheading1="{{subheading1}}" subheading2="{{subheading2}}"
  *ngIf="showDisbursedDataTable">





  <!-- <input class="date" type="month" id="start" name="start" min="2022-01" [max]="maxDate" [(ngModel)]="formatFilterTableDate"    #date1
    >
  
    <button class="ml-10px mybutton" (click)="submitDates()">Submit</button> -->
  <wl-date-input (dateRangeSelected)="onDateRangeSelected($event)" *ngIf="!isCoLogin()"></wl-date-input>

  <span *ngIf="showSelectedDate && !isCoLogin()" class="datetext">&nbsp;&nbsp;{{selectedDate}}&nbsp;&nbsp;<img
      src="../../../assets/fontawesome-web/svgs/regular/rectangle-xmark.svg" class="h-15px"
      (click)="closeButtonClick()">
  </span>





  <!-- <div>
      <mat-form-field class="w-full">
        <input type="text" matInput placeholder="{{searchHolder}}" (input)="onSearchClick($event)" [formControl]="search"><img
          class="ml-neg30px-important" src="../../../assets/svg/search.svg">
      </mat-form-field>
    </div> -->
  <wl-search-input (searchValueChanged)="onSearch($event)" [ngClass]="{'search': isCoLogin()}"></wl-search-input>
  <br>

  <p *ngIf="noUserFound" class="m-100px text-center font-size-15em">{{noUserFound}}</p>

  <div *ngIf="!noUserFound" child-container class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th class="vertical-align-top">Sr. No.</th>
          <th class="vertical-align-top">Loan Ref. No.<br>
          <th class="vertical-align-top">Loan Acc. No.<br>
          <th class="vertical-align-top">Borrower Name<br>
          <th class="vertical-align-top">Cust. ID<br>
          <th class="vertical-align-top">Sanction Date<br>
          <th class="vertical-align-top">Document Execution <br>Date<br>
          <th class="vertical-align-top"> Loan Account Open Date<br>
          <th class="vertical-align-top">Sanctioned Amount <br>(Max Allowed Limit)<br>
          <th class="vertical-align-top">1st Year DP<br>
          <th class="vertical-align-top">Download Documents<br>
          <th *ngIf="showChargeCreation" class="vertical-align-top">Charge Creation<br>
          <th class="vertical-align-top" *ngIf="roleId == 1">Zone</th>
          <th class="vertical-align-top" *ngIf="roleId == 1 || roleId == 21 || roleId == 2">RO</th>
          <th class="vertical-align-top"
            *ngIf="roleId == 1 || roleId == 21 || roleId == 2 || roleId == 3 || roleId== 31">Branch</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let user of allUsers;let i = index;">

          <td class="vertical-align-middle">
            <p>{{10 *(pageId-1)+i+1}}</p>
          </td>
          <td class="vertical-align-middle">
            <p>{{user?.ubi_reference_no?user?.ubi_reference_no: 'Loan Reference Number not available' }}</p>
          </td>
          <td class="vertical-align-middle">
            <p>{{user.loanAccountNo}}</p>
          </td>
          <td class="vertical-align-middle">
            <!-- <p>{{user.profile?.cust_title + " " + user.profile?.first_name + " "+ user.profile?.last_name}}</p> -->
            <p>{{(user?.profile?.first_name) ? user.profile.first_name : "" }}</p>
          </td>
          <td class="vertical-align-middle">
            <p>{{user?.custId}}</p>
          </td>
          <td class="vertical-align-middle">
            <p>{{user?.loanApplicationDate | date:'dd/MM/yy'}}</p>
          </td>
          <td class="vertical-align-middle">
            <p>{{user?.lde_date | date:'dd/MM/yy'}}</p>
          </td>
          <td class="vertical-align-middle">
            <p>{{user?.loanCreationDate | date:'dd/MM/yy'}}</p>
          </td>
          <td class="vertical-align-middle">
            <p>{{user?.croppingPatternProposed?.colU}}</p>
          </td>
          <td class="text-center vertical-align-middle">
            <p>{{user?.croppingPatternProposed?.colK}}</p>
          </td>
          <td (click)="getDocs(user);" class="download-docs vertical-align-middle">
            <P>Download</P>
          </td>
          <td *ngIf="showChargeCreation" class="text-center vertical-align-middle">
            <p>{{extractChargeDetailsFromJson(user)}}</p>
            <!-- <p>{{user?.chargeDetails?.response.STATUS =='SUCCESS'? 'Success' : (user?.chargeDetails?.response.STATUS =='Failed'? 'Failed' : 'Pending')}}</p> -->
          </td>
          <td class="text-center vertical-align-middle" *ngIf="roleId == 1">
            <p>{{user?.zone_name}}</p>
          </td>
          <td class="text-center vertical-align-middle" *ngIf="roleId == 1 || roleId == 21 || roleId == 2">
            <p>{{user?.ro_name}}</p>
          </td>
          <td class="text-center vertical-align-middle"
            *ngIf="roleId == 1 || roleId == 21 || roleId == 2 || roleId == 3 || roleId== 31">
            <p>{{user?.branch_name}}</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!--Moadal for Download Doc-->
  <!-- <ng-template #downloadModal let-modal>
    <div class="modal-header1">
      <h4 class="modal-title" id="modal-basic-title">Download Documents</h4>
      <button type="button" class="close_icon" (click)="closeDownloadDocModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    
    <div class="modal-body-confirm">
      <h4>Please select the documents to be downloaded:</h4>
      <ng-container
        *ngFor="let form of downloadForms; let idx = index;"
        >
        <input type="checkbox" [id]="'myCheck1'+idx" [(ngModel)]="form.isChecked"/>    
        <label>{{form.label | titlecase}}</label> <br>    
      </ng-container>
      <input type="checkbox" id="uniqueCheckboxDisbursed" (change)="changeAccWiseBre($event)" #checkRef *ngIf="showAccwiseBreCheckBox" /> <label>Account wise BRE check</label><br>
      <input type="checkbox" [id]="'myCheck2'+idx" (change)="selectAllDownloadForms($event)"/>    
      <label>All</label> <br>  
    </div>
    
    <div class="modal-footer">
      <div class="w3-show-inline-block text-center">
        <div class="w3-bar">
          <button class="mybutton" (click)="downloadMyForms()">Download</button>
        </div>
        </div>
    </div>
  </ng-template> -->

  <div class="modal-background" *ngIf="showDownloadDocsModal">
    <!-- <ng-template #downloadModal let-modal> -->
    <div class="modal-content p-0">
      <div class="modal-header1">

        <h4 class="modal-title" id="modal-basic-title">Download Documents</h4>
        <button type="button" class="close_icon" (click)="closeDownloadDocModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body-confirm text-left">
        <h4>Please select the documents to be downloaded:</h4>
        <ng-container *ngFor="let form of downloadForms; let idx = index;">
          <input type="checkbox" [id]="'myCheck1'+idx" [(ngModel)]="form.isChecked" />
          <label>{{form.label | titlecase}}</label> <br>
        </ng-container>
        <input type="checkbox" id="uniqueCheckboxDisbursed" [checked]="wantAccWiseBreDownloaded"
          (change)="changeAccWiseBre($event)" #checkRef
          *ngIf="showAccwiseBreCheckBox" /> <label *ngIf="showAccwiseBreCheckBox">Account
          wise BRE check</label><br>
        <input type="checkbox" [id]="'myCheck2'+idx" [checked]="allDownloadFormsSelected"
          (change)="selectAllDownloadForms($event)" />
        <label>All</label> <br>
      </div>

      <div class="modal-footer">
        <div class="w3-show-inline-block text-center">
          <div class="w3-bar">
            <button class="mybutton" (click)="downloadMyForms()">Download</button>
          </div>
        </div>
      </div>
    </div>
    <!-- </ng-template> -->

  </div>
  <!--Moadal for Download Doc-->

  <nav class="flex-center" *ngIf="totalPage>1 && !this.noUserFound" aria-label="Page navigation example">
    <ul class="pagination">
      <!-- limit - 10 -->
      <li *ngIf="page>3"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">Previous</a></li>
      <li *ngIf="page>2"><a (click)="getAllUsersPage(filter,roleId,offset - 20,10,page - 2)">{{page - 2}}</a></li>
      <li *ngIf="page>1"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">{{page - 1}}</a></li>
      <li class="page-item active"><a (click)="getAllUsersPage(filter,roleId,offset,10,page)">{{page}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">{{page + 1}}</a>
      </li>
      <li *ngIf="page+1<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 20,10,page + 2)">{{page + 2}}</a>
      </li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">Next</a></li>
    </ul>
  </nav>




</wl-card>





<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
  integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p" crossorigin="anonymous" />